module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-144x144-df217f55b5d9a003502ec2593bd1d3fe.png";